import { HMObject } from "../../types/HMObject.js";
function getLongestPossibleAptForPlage(plage) {
    return (plage.end.heure * 60 +
        plage.end.minute -
        (plage.start.heure * 60 + plage.start.minute));
}
function getLongestPossibleAptForPlages(plages) {
    return Math.max(...plages.map(getLongestPossibleAptForPlage));
}
function getAllHMinForPlage(plage, size) {
    const start = new HMObject(plage.start);
    const end = new HMObject(plage.end);
    let result = [];
    for (let i = start.value; i < end.value; i = i + size) {
        result.push(new HMObject(i).getHourMinuteDTO());
    }
    return result;
}
export { getLongestPossibleAptForPlage, getLongestPossibleAptForPlages, getAllHMinForPlage, };
//# sourceMappingURL=plagesTools.js.map